import renderElement from './element';

export default renderElement.bind(null, 'li');




// WEBPACK FOOTER //
// ../~/idom-util/src/li.js